import { components } from '@/types/api';

export type FilterToBeCreatedByImport = {
  id: string;
  title: string;
};

export const FilterTypes = {
  PRIORITY: 'Priority',
  PROGRESS_STATUS: 'Progress status',
  RAG: 'RAG',
  SIZE: 'Size',
  CUSTOM_SINGLE: 'Custom single',
  CUSTOM_MULTI: 'Custom multi',
};

export type FilterWithSortOrder = components['schemas']['Filter'] & { sort_order?: number };
